export default "__VITE_ASSET__BaJWoew9__"